export { default } from "./button";
export type { IButtonProps } from "./button.types";
